import { UseQueryResult, useQuery } from "@tanstack/react-query"
import usePrivateAxios from "@/common/api/usePrivateAxios"
import { TransactionIdentifiersEventsFees } from "../types/transactionIdentifiersEventsFees.type"

export const useTransactionIdentifiersEventsFees: (id: string, enabled?: boolean) => UseQueryResult<TransactionIdentifiersEventsFees, unknown> = (id, enabled = false) => {
  const privateAxios = usePrivateAxios()
  return useQuery<{ data: { data: TransactionIdentifiersEventsFees } }, unknown, TransactionIdentifiersEventsFees>({
    queryKey: ['transactionIdentifiersEventsFees', id],
    queryFn: () => privateAxios.get(`/billing/transaction_identifiers/${id}/events_fees`),
    enabled: enabled,
    select: response => response.data.data
  })
}
